<template>
  <Patch>
    <h5 slot="title">藥櫃管理</h5>

  </Patch>
</template>

<script>
import Patch from '../common/AdminPatch';

export default {
  name: 'ADCManagement',
  components: {
    Patch,
  },
};
</script>



// WEBPACK FOOTER //
// ADCManagement.vue?78113782